module.exports = __webpack_public_path__ + "img/e-Rith.ca5de4e1.png";